import { render, staticRenderFns } from "./ExVideoCard.vue?vue&type=template&id=14d36da2&"
import script from "./ExVideoCard.vue?vue&type=script&lang=js&"
export * from "./ExVideoCard.vue?vue&type=script&lang=js&"
import style0 from "./ExVideoCard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports